import React from 'react';
import { ReactComponent as CloseIcon } from 'images/ic-arrow-forward.svg';
import styles from '../../Toasts.module.scss';

const CloseToast = () => {
  return (
    <div className={styles.closeBtn}>
      <CloseIcon className={styles.icon} />
    </div>
  );
};

export default CloseToast;
